<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			let type = this.$store.state.authentication.account_type;
			if (type != 'sa') {
				this.$router.push('/dashboard');
			}
		},
		data() {
			return {}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Administrators.vue